import { render } from "./Card.vue?vue&type=template&id=2422e22c&bindings={\"title\":\"props\",\"subtitle\":\"props\",\"text\":\"props\",\"imagesURLs\":\"props\",\"number\":\"props\",\"textHTML\":\"data\"}"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script